export default "__VITE_ASSET__EvIHW0yV__"